import { Button, TextField } from '@mui/material';
import { L } from 'harmony-language';
import React, { Dispatch, FC, SetStateAction, useState } from 'react';
import { ModalDialog } from '../../shared/containers/modal-dialog';
import { ChecklistTemplate } from '../../../types';

interface InstructionsProps {
    checklistTemplate: ChecklistTemplate;
    setChecklistTemplate: Dispatch<SetStateAction<ChecklistTemplate>>;
}

export const Instructions: FC<InstructionsProps> = (props) => {
    const { checklistTemplate, setChecklistTemplate } = props;
    const [instructionsModalOpen, setInstructionsModalOpen] = useState(false);

    return (
        <>
            <Button
                variant='outlined'
                color='primary'
                onClick={() => setInstructionsModalOpen(true)}
            >
                {L.instructions()}
            </Button>
            <ModalDialog
                open={instructionsModalOpen}
                onClose={() => setInstructionsModalOpen(false)}
                title={L.instructions()}
            >
                <TextField
                    value={checklistTemplate.instructions}
                    onChange={(e) => {
                        const newValue = e.target.value;

                        if (newValue === '') {
                            setChecklistTemplate(prev => ({ ...prev, instructions: null }));
                        } else {
                            setChecklistTemplate(prev => ({ ...prev, instructions: newValue }));
                        }
                    }}
                    multiline={true}
                    minRows={4}
                    fullWidth
                    style={{
                        width: '25vw',
                    }}
                />
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '1rem' }}>
                    <Button
                        variant='contained'
                        color='primary'
                        onClick={() => setInstructionsModalOpen(false)}
                    >
                        {L.close()}
                    </Button>
                </div>
            </ModalDialog>
        </>
    );
};
